module.exports = __webpack_public_path__ + "static/media/waves.c19d8e82.mp4";